import styled from 'styled-components'

export const StyledTraining = styled.div``
